import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// 1. 引入 Vant 组件库
import Vant from 'vant';

// 2. 引入 Vant 样式
import 'vant/lib/index.css';

// 3. 注册 Vant
Vue.use(Vant);

import request from '@/utils/request';

Vue.prototype.$http = request;

new Vue({
  render: h => h(App),
}).$mount('#app')
